// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fonts/Nunito-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("fonts/Manrope-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Roboto-Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "Nunito-Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "Manrope-Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}

.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #6e7686;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

body {
  /* background-color: #f0f0f0 !important; */
  margin: 0 auto;
  font-family: "Roboto-Regular", sans-serif;
  color: #1f2937;
  background-color: #ffffff;
}

:focus-visible {
  outline: 3px solid #ffffff !important;
  outline-offset: 3px !important;
  box-shadow: 0 0 0 6px #0056b3 !important;
}

a {
  color: #0056b3;
}

a:hover {
  color: #003f84;
}

.responsive-heading {
  font-size: 18px;
}

.responsive-date {
  font-size: 14px;
}

.responsive-number {
  font-size: 22px;
}

.responsive-label {
  font-size: 14px;
}

.preview:hover {
  background-color: #263f86 !important;
  color: #fff !important;
}

.custom-container {
  max-width: 1310px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 10px;
  padding-right: 10px;
}

/* .dropdown-toggle {
  width: 100% !important;
}
.dropdown-menu {
  width: 100% !important;
} */

/* Question Number Custom CSS */
.question-numbers-container {
  white-space: nowrap;
  overflow-x: auto;
  scrollbar-width: none;
}

.question-numbers-container::-webkit-scrollbar {
  display: none;
}

.question-number-box {
  display: inline-block;
  min-width: 50px;
  text-align: center;
  cursor: pointer;
}

.question-number-box.selected {
  border-color: #0056b3;
  background-color: #faceb1;
}

.horizontal-icons {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #ffffff;
  z-index: 1030;
  border-top: 1px solid #ddd;
}

.horizontal-icons .nav-link {
  color: #6c757d;
  padding: 10px 0 !important;
}

.horizontal-icons .nav-link.active {
  color: #263f86 !important;
}

.custom-nav-link {
  color: #6c757d;
  transition: color 0.3s ease;
}

.custom-nav-link.active {
  color: #263f86 !important;
  font-weight: bold;
}

.custom-nav-link.active svg {
  color: #263f86 !important; /* Active color for icons */
}

.spacing {
  margin-right: 20px !important;
}

.formal-text {
  /* textcolor for TMIS */
  color: #263f86 !important;
}

.answered {
  background-color: #ccd1d1;
  color: #000;
  font-weight: bold;
}

/* Vertical Naigation bar in dashboard */
.side-nav.active {
  background-color: #d1dff8;
  color: #263f86 !important;
  border-left: 4px solid #263f86;
  border-radius: 10px;
  width: 180px;
}

.nav-link {
  font-size: 1.2rem;
  margin-bottom: 1rem;
}

.nav-link:hover {
  background-color: #e8ebf0;
}

.sidebar {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  width: 250px;
}

/* Login Form */
.form-control {
  border-radius: 12px;
  padding: 10px;
  font-size: 16px;
}

.form-control:focus {
  box-shadow: 0 0 5px rgba(38, 63, 134, 0.5);
  border-color: #263f86;
}

.form-floating > label {
  color: #6c757d;
}

.form-control::placeholder {
  color: #6b7280;
  opacity: 1;
}

/* Button design for Login Page */
.modern-btn {
  background-color: #052b81 !important;
  color: #fff !important;
  border: none !important;
  padding: 12px 24px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border-radius: 5px !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;
}

.modern-btn:hover {
  background-color: #041f5b !important;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2) !important;
  transform: translateY(-2px) !important;
}

.modern-btn:focus {
  outline: none !important;
  box-shadow: 0 0 5px rgba(38, 63, 134, 0.5) !important;
}

.modern-btn:focus-visible {
  outline: 3px solid #ffffff !important;
  outline-offset: 3px !important;
  box-shadow: 0 0 0 6px #0056b3 !important;
}

.modern-btn:active {
  transform: translateY(2px) !important;
}

/* ---------------------------------- */

/* Circular Progress Css */
.circular-progress-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.circular-progress {
  transform: rotate(-90deg);
}

.circle-bg {
  opacity: 0.3;
}

.circle-fg {
  transform: rotate(90deg);
}

.percentage-text {
  position: absolute;
  font-size: 1.5rem;
  font-weight: bold;
  color: #0056b3; /* Text color */
}

/* ------------------------------- */
.card-image {
  width: 100%;
  height: 100px;
  object-fit: cover;
}

.custom-checkbox .form-check-input {
  width: 50px;
  height: calc(1.5em + 0.75rem + 2px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-icon-color {
  color: #263f86 !important;
}

.button-color {
  background-color: #263f86 !important;
}

.content {
  color: #263f86;
  padding: 20px;
}

.App-link {
  color: #0056b3;
}

/* Custom Container for the data table */
.container {
  margin: 10px auto;
  max-width: 950px;
}

/* Styles for the table */
.data-table {
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

/* Table title styling */
.data-table-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}

/* Header cell styling */
.data-table thead th {
  background-color: #f8f9fa;
  color: #cf0f0f;
  font-size: 16px;
  font-weight: bold;
  padding: 12px;
}

/* Row styling */
.data-table tbody tr {
  font-size: 15px;
  color: #555;
}

.data-table tbody tr:hover {
  background-color: #f1f1f1;
}

/* Pagination styling */
.data-table-pagination {
  background-color: #f8f9fa;
  border-top: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}

/* --------- Design for Cards ----------- */
.cards-container {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 10px;
}

/* Card styling for Dashboard */
.card-dashboard {
  background-color: #fff;
  padding: 16px;
  border: 1px solid #ddd;
  border-radius: 8px;
  width: 150px;
  text-align: center;
}

.card-dashboard h5 {
  font-size: 16px;
  color: #ffffff;
  margin: 0;
}

.card-dashboard p {
  font-size: 30px;
  color: #ffffff;
  font-weight: bold;
  margin: 10px;
}

/* ---- List view Design ---- */
.event-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  padding: 15px;
  transition: transform 0.2s;
}
.event-card:hover {
  transform: scale(1.02);
}
.event-card.cancelled {
  background: repeating-linear-gradient(
    -45deg,
    #f8d7da,
    #f8d7da 10px,
    #ffffff 10px,
    #ffffff 20px
  );
}
.date-box {
  background: #263f86;
  color: white;
  padding: 10px 15px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 50px;
}
.date-box .day {
  font-size: 24px;
  font-weight: bold;
}
.date-box .month {
  font-size: 14px;
}
.event-title {
  font-weight: bold;
  color: #263f86;
}
.event-time, .event-location, .event-type {
  font-size: 14px;
  color: #666;
  margin: 2px 0;
}

.event-circle {
  width: 8px;
  height: 8px;
  background-color: #b91c1c; /* Event marker color */
  border-radius: 50%;
  margin: auto;
}

.notification-container {
  background: #fff;
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  width: 320px;
}

.menu-color{
  color:#676e74 !important;
}

.notification-card {
  background: #f8f9fa;
  border-radius: 8px;
  border-left: solid #263f86;
  padding: 12px;
  margin: 10px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.notification-content {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.notification-description {
  color: #6c757d;
  font-size: 14px;
  margin-top: 2px;
}

.close-btn {
  background: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
}
.close-btn:hover {
  color: red;
}


/* ---------------------------------- */

@media (max-width: 768px) {
  .content-wrapper {
    padding-bottom: 120px;
  }

  .card-title {
    font-size: 14px;
  }
  .card-subtitle {
    font-size: 12px;
  }

  .card-wrapper {
    padding: 10px;
  }

  .card-wrapper .d-flex {
    flex-wrap: wrap;
  }

  .card-wrapper .w-100 {
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .card-wrapper span {
    font-size: 14px;
    margin-bottom: 5px;
  }

  .card-wrapper .btn-sm {
    font-size: 12px;
    width: 100%;
    margin-top: 5px;
  }

  .card-wrapper p {
    font-size: 8px;
    padding: 2px 5px;
    margin: 10px 0;
  }

  .card-wrapper svg {
    margin: 10px 0;
  }

  .mobile-text{
    font-size: 12px;
  }
  h5.mobile-header{
    font-size: 16px !important;
  }

  .small-text{
    font-size: 10px;
    color: black !important;
  }

  .mobile-button{
    font-size: 11px !important;
  }

  .mobile-questions{
    font-size: 12px !important;
  }

  .mobile-answers{
    font-size: 12px !important;
  }
}

@media (max-width: 576px) {
  .card-wrapper {
    padding: 5px;
  }

  .card-wrapper span {
    font-size: 12px;
  }

  .card-wrapper .btn-sm {
    font-size: 10px;
  }

  .card-wrapper p {
    font-size: 7px;
  }

  .responsive-heading {
    font-size: 16px;
  }

  .responsive-date {
    font-size: 12px;
  }

  .responsive-number {
    font-size: 20px;
  }

  .responsive-label {
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,+DAAuD;EACvD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,+DAAuD;EACvD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,+DAAwD;EACxD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,yCAAyC;EACzC,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;;;GAKG;;AAEH,+BAA+B;AAC/B;EACE,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB,EAAE,2BAA2B;AACxD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;AACnB;;AAEA,wCAAwC;AACxC;EACE,yBAAyB;EACzB,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,OAAO;EACP,YAAY;AACd;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA,iCAAiC;AACjC;EACE,oCAAoC;EACpC,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,oCAAoC;EACpC,mDAAmD;AACrD;;AAEA;EACE,oCAAoC;EACpC,oDAAoD;EACpD,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;EACxB,qDAAqD;AACvD;;AAEA;EACE,qCAAqC;EACrC,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;AACvC;;AAEA,uCAAuC;;AAEvC,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc,EAAE,eAAe;AACjC;;AAEA,oCAAoC;AACpC;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA,wCAAwC;AACxC;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;AACpB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,YAAY;AACd;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,aAAa;EACb,0BAA0B;AAC5B;AACA;EACE,sBAAsB;AACxB;AACA;EACE;;;;;;GAMC;AACH;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,eAAe;EACf,WAAW;EACX,aAAa;AACf;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB,EAAE,uBAAuB;EAClD,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;EACE,UAAU;AACZ;;;AAGA,uCAAuC;;AAEvC;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,8BAA8B;IAC9B,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["@font-face {\n  font-family: \"Roboto-Regular\";\n  src: url(\"fonts/Roboto-Regular.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Nunito-Regular\";\n  src: url(\"fonts/Nunito-Regular.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Manrope-Regular\";\n  src: url(\"fonts/Manrope-Regular.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #6e7686;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\nbody {\n  /* background-color: #f0f0f0 !important; */\n  margin: 0 auto;\n  font-family: \"Roboto-Regular\", sans-serif;\n  color: #1f2937;\n  background-color: #ffffff;\n}\n\n:focus-visible {\n  outline: 3px solid #ffffff !important;\n  outline-offset: 3px !important;\n  box-shadow: 0 0 0 6px #0056b3 !important;\n}\n\na {\n  color: #0056b3;\n}\n\na:hover {\n  color: #003f84;\n}\n\n.responsive-heading {\n  font-size: 18px;\n}\n\n.responsive-date {\n  font-size: 14px;\n}\n\n.responsive-number {\n  font-size: 22px;\n}\n\n.responsive-label {\n  font-size: 14px;\n}\n\n.preview:hover {\n  background-color: #263f86 !important;\n  color: #fff !important;\n}\n\n.custom-container {\n  max-width: 1310px;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n/* .dropdown-toggle {\n  width: 100% !important;\n}\n.dropdown-menu {\n  width: 100% !important;\n} */\n\n/* Question Number Custom CSS */\n.question-numbers-container {\n  white-space: nowrap;\n  overflow-x: auto;\n  scrollbar-width: none;\n}\n\n.question-numbers-container::-webkit-scrollbar {\n  display: none;\n}\n\n.question-number-box {\n  display: inline-block;\n  min-width: 50px;\n  text-align: center;\n  cursor: pointer;\n}\n\n.question-number-box.selected {\n  border-color: #0056b3;\n  background-color: #faceb1;\n}\n\n.horizontal-icons {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  background-color: #ffffff;\n  z-index: 1030;\n  border-top: 1px solid #ddd;\n}\n\n.horizontal-icons .nav-link {\n  color: #6c757d;\n  padding: 10px 0 !important;\n}\n\n.horizontal-icons .nav-link.active {\n  color: #263f86 !important;\n}\n\n.custom-nav-link {\n  color: #6c757d;\n  transition: color 0.3s ease;\n}\n\n.custom-nav-link.active {\n  color: #263f86 !important;\n  font-weight: bold;\n}\n\n.custom-nav-link.active svg {\n  color: #263f86 !important; /* Active color for icons */\n}\n\n.spacing {\n  margin-right: 20px !important;\n}\n\n.formal-text {\n  /* textcolor for TMIS */\n  color: #263f86 !important;\n}\n\n.answered {\n  background-color: #ccd1d1;\n  color: #000;\n  font-weight: bold;\n}\n\n/* Vertical Naigation bar in dashboard */\n.side-nav.active {\n  background-color: #d1dff8;\n  color: #263f86 !important;\n  border-left: 4px solid #263f86;\n  border-radius: 10px;\n  width: 180px;\n}\n\n.nav-link {\n  font-size: 1.2rem;\n  margin-bottom: 1rem;\n}\n\n.nav-link:hover {\n  background-color: #e8ebf0;\n}\n\n.sidebar {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 250px;\n}\n\n/* Login Form */\n.form-control {\n  border-radius: 12px;\n  padding: 10px;\n  font-size: 16px;\n}\n\n.form-control:focus {\n  box-shadow: 0 0 5px rgba(38, 63, 134, 0.5);\n  border-color: #263f86;\n}\n\n.form-floating > label {\n  color: #6c757d;\n}\n\n.form-control::placeholder {\n  color: #6b7280;\n  opacity: 1;\n}\n\n/* Button design for Login Page */\n.modern-btn {\n  background-color: #052b81 !important;\n  color: #fff !important;\n  border: none !important;\n  padding: 12px 24px !important;\n  font-size: 16px !important;\n  font-weight: 600 !important;\n  border-radius: 5px !important;\n  transition: all 0.3s ease !important;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;\n}\n\n.modern-btn:hover {\n  background-color: #041f5b !important;\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2) !important;\n  transform: translateY(-2px) !important;\n}\n\n.modern-btn:focus {\n  outline: none !important;\n  box-shadow: 0 0 5px rgba(38, 63, 134, 0.5) !important;\n}\n\n.modern-btn:focus-visible {\n  outline: 3px solid #ffffff !important;\n  outline-offset: 3px !important;\n  box-shadow: 0 0 0 6px #0056b3 !important;\n}\n\n.modern-btn:active {\n  transform: translateY(2px) !important;\n}\n\n/* ---------------------------------- */\n\n/* Circular Progress Css */\n.circular-progress-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.circular-progress {\n  transform: rotate(-90deg);\n}\n\n.circle-bg {\n  opacity: 0.3;\n}\n\n.circle-fg {\n  transform: rotate(90deg);\n}\n\n.percentage-text {\n  position: absolute;\n  font-size: 1.5rem;\n  font-weight: bold;\n  color: #0056b3; /* Text color */\n}\n\n/* ------------------------------- */\n.card-image {\n  width: 100%;\n  height: 100px;\n  object-fit: cover;\n}\n\n.custom-checkbox .form-check-input {\n  width: 50px;\n  height: calc(1.5em + 0.75rem + 2px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.nav-icon-color {\n  color: #263f86 !important;\n}\n\n.button-color {\n  background-color: #263f86 !important;\n}\n\n.content {\n  color: #263f86;\n  padding: 20px;\n}\n\n.App-link {\n  color: #0056b3;\n}\n\n/* Custom Container for the data table */\n.container {\n  margin: 10px auto;\n  max-width: 950px;\n}\n\n/* Styles for the table */\n.data-table {\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n/* Table title styling */\n.data-table-title {\n  font-size: 20px;\n  font-weight: bold;\n  color: #333;\n  margin-bottom: 10px;\n}\n\n/* Header cell styling */\n.data-table thead th {\n  background-color: #f8f9fa;\n  color: #cf0f0f;\n  font-size: 16px;\n  font-weight: bold;\n  padding: 12px;\n}\n\n/* Row styling */\n.data-table tbody tr {\n  font-size: 15px;\n  color: #555;\n}\n\n.data-table tbody tr:hover {\n  background-color: #f1f1f1;\n}\n\n/* Pagination styling */\n.data-table-pagination {\n  background-color: #f8f9fa;\n  border-top: 1px solid #ddd;\n  padding: 8px;\n  text-align: center;\n}\n\n/* --------- Design for Cards ----------- */\n.cards-container {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n/* Card styling for Dashboard */\n.card-dashboard {\n  background-color: #fff;\n  padding: 16px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  width: 150px;\n  text-align: center;\n}\n\n.card-dashboard h5 {\n  font-size: 16px;\n  color: #ffffff;\n  margin: 0;\n}\n\n.card-dashboard p {\n  font-size: 30px;\n  color: #ffffff;\n  font-weight: bold;\n  margin: 10px;\n}\n\n/* ---- List view Design ---- */\n.event-card {\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);\n  padding: 15px;\n  transition: transform 0.2s;\n}\n.event-card:hover {\n  transform: scale(1.02);\n}\n.event-card.cancelled {\n  background: repeating-linear-gradient(\n    -45deg,\n    #f8d7da,\n    #f8d7da 10px,\n    #ffffff 10px,\n    #ffffff 20px\n  );\n}\n.date-box {\n  background: #263f86;\n  color: white;\n  padding: 10px 15px;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-width: 50px;\n}\n.date-box .day {\n  font-size: 24px;\n  font-weight: bold;\n}\n.date-box .month {\n  font-size: 14px;\n}\n.event-title {\n  font-weight: bold;\n  color: #263f86;\n}\n.event-time, .event-location, .event-type {\n  font-size: 14px;\n  color: #666;\n  margin: 2px 0;\n}\n\n.event-circle {\n  width: 8px;\n  height: 8px;\n  background-color: #b91c1c; /* Event marker color */\n  border-radius: 50%;\n  margin: auto;\n}\n\n.notification-container {\n  background: #fff;\n  border-radius: 10px;\n  padding: 15px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n  width: 320px;\n}\n\n.menu-color{\n  color:#676e74 !important;\n}\n\n.notification-card {\n  background: #f8f9fa;\n  border-radius: 8px;\n  border-left: solid #263f86;\n  padding: 12px;\n  margin: 10px 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n}\n\n.notification-content {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.notification-description {\n  color: #6c757d;\n  font-size: 14px;\n  margin-top: 2px;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  font-size: 16px;\n  cursor: pointer;\n}\n.close-btn:hover {\n  color: red;\n}\n\n\n/* ---------------------------------- */\n\n@media (max-width: 768px) {\n  .content-wrapper {\n    padding-bottom: 120px;\n  }\n\n  .card-title {\n    font-size: 14px;\n  }\n  .card-subtitle {\n    font-size: 12px;\n  }\n\n  .card-wrapper {\n    padding: 10px;\n  }\n\n  .card-wrapper .d-flex {\n    flex-wrap: wrap;\n  }\n\n  .card-wrapper .w-100 {\n    justify-content: space-between;\n    flex-wrap: wrap;\n  }\n\n  .card-wrapper span {\n    font-size: 14px;\n    margin-bottom: 5px;\n  }\n\n  .card-wrapper .btn-sm {\n    font-size: 12px;\n    width: 100%;\n    margin-top: 5px;\n  }\n\n  .card-wrapper p {\n    font-size: 8px;\n    padding: 2px 5px;\n    margin: 10px 0;\n  }\n\n  .card-wrapper svg {\n    margin: 10px 0;\n  }\n\n  .mobile-text{\n    font-size: 12px;\n  }\n  h5.mobile-header{\n    font-size: 16px !important;\n  }\n\n  .small-text{\n    font-size: 10px;\n    color: black !important;\n  }\n\n  .mobile-button{\n    font-size: 11px !important;\n  }\n\n  .mobile-questions{\n    font-size: 12px !important;\n  }\n\n  .mobile-answers{\n    font-size: 12px !important;\n  }\n}\n\n@media (max-width: 576px) {\n  .card-wrapper {\n    padding: 5px;\n  }\n\n  .card-wrapper span {\n    font-size: 12px;\n  }\n\n  .card-wrapper .btn-sm {\n    font-size: 10px;\n  }\n\n  .card-wrapper p {\n    font-size: 7px;\n  }\n\n  .responsive-heading {\n    font-size: 16px;\n  }\n\n  .responsive-date {\n    font-size: 12px;\n  }\n\n  .responsive-number {\n    font-size: 20px;\n  }\n\n  .responsive-label {\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
